import {
  type ExportResultEntity,
  ExportResultSchema
} from '@/core/infrastructure/schemas/exports/ExportSchema.ts'
import { EntityValidator } from '@/core/infrastructure/utils/EntityValidator.ts'

export default class ExportResult {
  readonly filename: string
  readonly blob: Blob

  constructor(result: ExportResultEntity) {
    this.filename = result.filename
    this.blob = result.blob
  }

  public static create(data: unknown): ExportResult {
    return EntityValidator.validateAndCreate(ExportResultSchema, data, ExportResult, 'ExportResult')
  }
}